import type { ReactNode } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

// #redesign Welle C (#6) — Such-/Filterleiste über Listen-Tabellen.
// Suche ist client-side (Listen laden ohnehin alle Zeilen). children = optionale
// Filter-Slots (z.B. Phase-Dropdown bei Agents).
export function ListToolbar({
  search,
  onSearch,
  placeholder = "Suche…",
  children,
}: {
  search: string;
  onSearch: (value: string) => void;
  placeholder?: string;
  children?: ReactNode;
}) {
  return (
    <div className="mb-3 flex flex-wrap items-center gap-2">
      <div className="relative min-w-[200px] max-w-sm flex-1">
        <Search className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-subtext0" />
        <Input
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder={placeholder}
          className="pl-8"
          data-testid="list-search"
        />
      </div>
      {children}
    </div>
  );
}
